import {
    RiChat1Line,
    RiComputerLine,
    RiDownload2Line,
    RiEmotion2Line,
    RiFileList2Line, RiFlashlightLine,
    RiMailLine,
} from "@remixicon/react";
import React from "react";
import {
    ActionContextType,
    WorkflowTriggerType,
} from "../../../../__generated__/api";

import Badge from "../../../../components/theme/badge/Badge";
import Icon from "../../../../components/theme/icon/Icon";
import ActionGeneralDetails from "./general-settings/ActionGeneralDetails";
import EmojiGeneralDetails from "./general-settings/EmojiGeneralDetails";
import InboundWebhookGeneralDetails from "./general-settings/InboundWebhookGeneralDetails";
import BaseGeneralSettings from "./general-settings/BaseGeneralDetails";

export default {
    [WorkflowTriggerType.Action]: {
        value: WorkflowTriggerType.Action,
        badge: <Badge variant="gray" prefixIcon={<RiFlashlightLine />}>Action</Badge>,
        text: "Action",
        canCreate: true,
        description: "Manually triggered by the agent in the dashboard.",
        icon: <RiFlashlightLine />,
        createOrder: 4,
        actionContextType: ActionContextType.Ticket,
        label: (
            <div>
                <Icon icon={<RiFlashlightLine />} variant="secondary" />
                {" "}
                Action
            </div>
        ),
        component: ActionGeneralDetails,
        hasFormBuilder: true,
    },
    [WorkflowTriggerType.ChannelTag]: {
        value: WorkflowTriggerType.ChannelTag,
        badge: <Badge variant="gray" prefixIcon={<Icon.ChannelTag />}>Channel Group</Badge>,
        text: "Channel Group",
        canCreate: true,
        description: "Triggered when a user creates a ticket in a channel thats part of the group.",
        icon: <Icon.ChannelTag />,
        createOrder: 2,
        actionContextType: ActionContextType.Ticket,
        label: (
            <div>
                <Icon.ChannelTag variant="secondary" />
                {" "}
                Channel Group
            </div>
        ),
        component: BaseGeneralSettings,
        hasFormBuilder: false,
    },
    [WorkflowTriggerType.Email]: {
        value: WorkflowTriggerType.Email,
        badge: <Badge variant="gray" prefixIcon={<RiMailLine />}>Email</Badge>,
        text: "Email",
        canCreate: true,
        description: "Triggered when a user sends an email to your Foqal account.",
        icon: <RiMailLine />,
        createOrder: 3,
        actionContextType: ActionContextType.Ticket,
        label: (
            <div>
                <Icon icon={<RiMailLine />} variant="secondary" />
                {" "}
                Email
            </div>
        ),
        component: BaseGeneralSettings,
        hasFormBuilder: false,
    },
    [WorkflowTriggerType.Emoji]: {
        value: WorkflowTriggerType.Emoji,
        badge: <Badge variant="gray" prefixIcon={<RiEmotion2Line />}>Emoji</Badge>,
        text: "Emoji",
        canCreate: true,
        description: "Triggered when a user adds an emoji to an existing thread in a channel like Slack.",
        icon: <RiEmotion2Line />,
        createOrder: 1,
        actionContextType: ActionContextType.Ticket,
        label: (
            <div>
                <Icon icon={<RiEmotion2Line />} variant="secondary" />
                {" "}
                Emoji
            </div>
        ),
        component: EmojiGeneralDetails,
        hasFormBuilder: false,
    },
    [WorkflowTriggerType.InboundWebhook]: {
        value: WorkflowTriggerType.InboundWebhook,
        badge: <Badge variant="gray" prefixIcon={<RiDownload2Line />}>Webhook</Badge>,
        text: "Webhook",
        canCreate: true,
        description: "Triggered when an external service sends a webhook to Foqal.",
        icon: <RiDownload2Line />,
        createOrder: 6,
        actionContextType: ActionContextType.Webhook,
        label: (
            <div>
                <Icon icon={<RiDownload2Line />} variant="secondary" />
                {" "}
                Webhook
            </div>
        ),
        component: InboundWebhookGeneralDetails,
        hasFormBuilder: false,
    },
    [WorkflowTriggerType.RequestType]: {
        value: WorkflowTriggerType.RequestType,
        badge: <Badge variant="gray" prefixIcon={<RiFileList2Line />}>Request Type</Badge>,
        text: "Request Type",
        canCreate: true,
        description: "Triggered when a user creates a ticket after filling out a request form.",
        icon: <RiFileList2Line />,
        createOrder: 0,
        actionContextType: ActionContextType.Ticket,
        label: (
            <div>
                <Icon icon={<RiFileList2Line />} variant="secondary" />
                {" "}
                Request Type
            </div>
        ),
        component: null,
        hasFormBuilder: false,
    },
    [WorkflowTriggerType.WebChat]: {
        value: WorkflowTriggerType.WebChat,
        badge: <Badge variant="gray" prefixIcon={<RiChat1Line />}>Web Chat</Badge>,
        text: "Web Chat",
        canCreate: true,
        description: "Triggered when a user sends a chat message.",
        icon: <RiChat1Line />,
        createOrder: 5,
        actionContextType: ActionContextType.Ticket,
        label: (
            <div>
                <Icon icon={<RiChat1Line />} variant="secondary" />
                {" "}
                Web Chat
            </div>
        ),
        component: BaseGeneralSettings,
        hasFormBuilder: false,
    },
    [WorkflowTriggerType.WorkspaceAction]: {
        value: WorkflowTriggerType.WorkspaceAction,
        badge: <Badge variant="gray" prefixIcon={<RiComputerLine />}>System</Badge>,
        text: "System",
        canCreate: true,
        description: "Triggered automatically when certain actions occur in the system such as a channel is added to Foqal.",
        icon: <RiComputerLine />,
        createOrder: 7,
        actionContextType: ActionContextType.GenericNoTicket,
        label: (
            <div>
                <Icon icon={<RiComputerLine />} variant="secondary" />
                {" "}
                System
            </div>
        ),
        component: BaseGeneralSettings,
        hasFormBuilder: false,
    },
    [WorkflowTriggerType.Integration]: {
        value: WorkflowTriggerType.Integration,
        badge: <Badge variant="gray" prefixIcon={<Icon.Integrations />}>Integration</Badge>,
        text: "Integration",
        canCreate: false,
        description: "Triggered by an external integration.",
        icon: <Icon.Integrations />,
        createOrder: 0,
        label: undefined,
        component: BaseGeneralSettings,
        actionContextType: ActionContextType.GenericNoTicket,
        hasFormBuilder: false,
    },
};
